import { render, staticRenderFns } from "./MemoInboxForm.vue?vue&type=template&id=6ebe9a7c&"
import script from "./MemoInboxForm.vue?vue&type=script&lang=js&"
export * from "./MemoInboxForm.vue?vue&type=script&lang=js&"
import style0 from "./MemoInboxForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports